export interface Movie {
  id: string;
  title: string;
  englishTitle: string;
  year: number;
  category: string;
  categorySlug: string;
  rating: number;
  description: string;
  posterImage: string;
  bannerImage: string;
  director: string;
  cast: string[];
  duration: string;
  type: 'movie' | 'tv';
  region: string;
  updateStatus: string;
  tags: string[];
  featured: boolean;
  releaseDate: string;
  viewCount: number;
}

export const categories = [
  { name: '全部', slug: 'all', icon: 'ri-movie-line' },
  { name: '动作片', slug: 'action', icon: 'ri-fire-line' },
  { name: '喜剧片', slug: 'comedy', icon: 'ri-emotion-happy-line' },
  { name: '爱情片', slug: 'romance', icon: 'ri-heart-line' },
  { name: '科幻片', slug: 'scifi', icon: 'ri-rocket-line' },
  { name: '恐怖片', slug: 'horror', icon: 'ri-ghost-line' },
  { name: '剧情片', slug: 'drama', icon: 'ri-film-line' },
  { name: '动画片', slug: 'animation', icon: 'ri-emotion-laugh-line' },
  { name: '纪录片', slug: 'documentary', icon: 'ri-camera-line' },
  { name: '电视剧', slug: 'tv', icon: 'ri-tv-line' },
];

export const movies: Movie[] = [
  {
    id: '1',
    title: '流浪地球3',
    englishTitle: 'The Wandering Earth 3',
    year: 2026,
    category: '科幻片',
    categorySlug: 'scifi',
    rating: 9.2,
    description: '太阳急速老化，持续膨胀，地球面临被吞没的灭顶之灾。为了生存，人类在地球表面建造了一万座行星发动机，推动地球逃离太阳系，踏上了长达2500年的宇宙流浪之旅。在这场跨越时空的壮丽冒险中，人类文明的火种能否在茫茫宇宙中延续？全新篇章将带领观众见证更宏大的宇宙征程。',
    posterImage: 'https://readdy.ai/api/search-image?query=A%20stunning%20sci-fi%20movie%20poster%20showing%20a%20massive%20planet%20Earth%20with%20glowing%20engines%20in%20deep%20space%20with%20stars%20and%20nebula%20cinematic%20lighting%20dramatic%20composition%20warm%20orange%20and%20deep%20blue%20color%20palette%20clean%20background&width=600&height=840&seq=movie-poster-01&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20cinematic%20banner%20showing%20a%20giant%20planet%20Earth%20traveling%20through%20space%20with%20massive%20blue%20engine%20flames%20dramatic%20cinematic%20lighting%20deep%20space%20stars%20warm%20orange%20glow%20epic%20scale%20atmospheric%20haze%20movie%20theater%20quality&width=1600&height=700&seq=movie-banner-01&orientation=landscape',
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢', '宁理', '王智'],
    duration: '148分钟',
    type: 'movie',
    region: '中国大陆',
    updateStatus: '已上映',
    tags: ['科幻', '灾难', '冒险', '太空', '国产大片', '刘慈欣'],
    featured: true,
    releaseDate: '2026-02-10',
    viewCount: 89560000,
  },
  {
    id: '2',
    title: '长安十二时辰',
    englishTitle: 'The Longest Day in Chang\'an',
    year: 2025,
    category: '电视剧',
    categorySlug: 'tv',
    rating: 8.9,
    description: '唐朝天宝三年，上元节前夕，长安城陷入了一场惊天危机。死囚张小敬临危受命，与少年名士李必携手，在十二个时辰之内，必须在偌大的长安城中找出潜藏的狼卫，拯救这座千年古都于水火之中。一场惊心动魄的追逐战，在盛唐的繁华与暗流中展开。',
    posterImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Chinese%20historical%20drama%20poster%20showing%20ancient%20Tang%20Dynasty%20soldier%20in%20armor%20standing%20before%20ancient%20city%20walls%20at%20night%20with%20lanterns%20warm%20golden%20light%20epic%20cinematic%20composition%20clean%20dark%20background&width=600&height=840&seq=movie-poster-02&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20Dynasty%20cityscape%20at%20night%20with%20red%20lanterns%20ancient%20architecture%20crowded%20streets%20dramatic%20cinematic%20lighting%20warm%20golden%20tones%20atmospheric%20fog%20palace%20walls%20epic%20scale&width=1600&height=700&seq=movie-banner-02&orientation=landscape',
    director: '曹盾',
    cast: ['雷佳音', '易烊千玺', '周一围', '热依扎', '韩童生', '芦芳生'],
    duration: '48集',
    type: 'tv',
    region: '中国大陆',
    updateStatus: '全48集',
    tags: ['古装', '悬疑', '历史', '动作', '唐朝', '马伯庸'],
    featured: true,
    releaseDate: '2025-06-15',
    viewCount: 120500000,
  },
  {
    id: '3',
    title: '红海行动2：深海突击',
    englishTitle: 'Operation Red Sea 2',
    year: 2026,
    category: '动作片',
    categorySlug: 'action',
    rating: 9.0,
    description: '蛟龙突击队再次集结，深入深海执行一项绝密救援任务。在暗流涌动的大洋深处，他们不仅要面对敌方的重重围堵，还要与时间赛跑，拯救被困的科研人员和极其重要的实验数据。一场惊心动魄的海底战斗即将打响。',
    posterImage: 'https://readdy.ai/api/search-image?query=A%2520thrilling%2520action%2520movie%2520poster%2520showing%2520special%2520forces%2520soldiers%2520in%2520tactical%2520gear%2520underwater%2520with%2520dramatic%252%200lighting%2520military%2520equipment%2520intense%2520expression%2520cinematic%2520composition%2520deep%2520blue%2520and%2520orange%2520color%2520scheme&width=600&height=840&seq=movie-poster-03&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Intense%20military%20action%20scene%20showing%20navy%20special%20forces%20on%20a%20warship%20at%20sea%20dramatic%20sunset%20lighting%20helicopter%20overhead%20explosive%20atmosphere%20epic%20cinematic%20quality%20warm%20orange%20and%20deep%20blue%20ocean&width=1600&height=700&seq=movie-banner-03&orientation=landscape',
    director: '林超贤',
    cast: ['张译', '黄景瑜', '海清', '杜江', '蒋璐霞', '尹昉'],
    duration: '135分钟',
    type: 'movie',
    region: '中国大陆',
    updateStatus: '已上映',
    tags: ['动作', '军事', '特种部队', '救援', '国产大片'],
    featured: true,
    releaseDate: '2026-03-18',
    viewCount: 76200000,
  },
  {
    id: '4',
    title: '你好，李焕英2',
    englishTitle: 'Hi, Mom 2',
    year: 2026,
    category: '喜剧片',
    categorySlug: 'comedy',
    rating: 8.7,
    description: '故事延续前作的温情与欢笑，这一次，贾晓玲意外穿越到了母亲年轻时的另一个时空节点。在这个全新的故事线中，她发现母亲年轻时还有一个未竟的梦想，于是决定用自己未来人的智慧，帮助妈妈完成人生中最大的遗憾。笑中带泪，温情满满。',
    posterImage: 'https://readdy.ai/api/search-image?query=A%20heartwarming%20comedy%20movie%20poster%20showing%20mother%20and%20daughter%20embracing%20with%20warm%20smiles%20vintage%201980s%20Chinese%20factory%20background%20soft%20golden%20lighting%20nostalgic%20atmosphere%20clean%20warm%20background&width=600&height=840&seq=movie-poster-04&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Nostalgic%201980s%20Chinese%20factory%20scene%20with%20workers%20in%20vintage%20clothing%20warm%20golden%20sunlight%20bicycles%20old%20buildings%20heartwarming%20atmosphere%20soft%20cinematic%20lighting%20retro%20Chinese%20street%20scene&width=1600&height=700&seq=movie-banner-04&orientation=landscape',
    director: '贾玲',
    cast: ['贾玲', '张小斐', '沈腾', '陈赫', '乔杉', '许君聪'],
    duration: '128分钟',
    type: 'movie',
    region: '中国大陆',
    updateStatus: '已上映',
    tags: ['喜剧', '亲情', '穿越', '温情', '感人'],
    featured: false,
    releaseDate: '2026-01-22',
    viewCount: 98500000,
  },
  {
    id: '5',
    title: '星际穿越2：新世界',
    englishTitle: 'Interstellar 2: New World',
    year: 2026,
    category: '科幻片',
    categorySlug: 'scifi',
    rating: 9.4,
    description: '库珀在宇宙的另一端苏醒，发现自己来到了一个全新的宜居星球。但这里并非无人之境——一种远超人类理解的高等文明留下了神秘的遗迹。为了人类的未来，他必须解开这些谜题，同时面对一个震撼人心的真相：人类在宇宙中并不孤单。',
    posterImage: 'https://readdy.ai/api/search-image?query=A%20breathtaking%20sci-fi%20movie%20poster%20showing%20an%20astronaut%20standing%20on%20an%20alien%20planet%20with%20two%20suns%20in%20the%20sky%20strange%20crystalline%20structures%20cinematic%20lighting%20deep%20space%20vibrant%20colors%20clean%20dark%20background&width=600&height=840&seq=movie-poster-05&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Breathtaking%20alien%20planet%20landscape%20with%20crystal%20formations%20twin%20suns%20in%20sky%20astronaut%20silhouette%20on%20horizon%20vibrant%20purple%20and%20gold%20sky%20cinematic%20epic%20scale%20atmospheric%20haze%20science%20fiction&width=1600&height=700&seq=movie-banner-05&orientation=landscape',
    director: '克里斯托弗·诺兰',
    cast: ['马修·麦康纳', '安妮·海瑟薇', '杰西卡·查斯坦', '迈克尔·凯恩'],
    duration: '169分钟',
    type: 'movie',
    region: '美国',
    updateStatus: '已上映',
    tags: ['科幻', '太空', '冒险', '诺兰', '好莱坞'],
    featured: true,
    releaseDate: '2026-05-08',
    viewCount: 156000000,
  },
  {
    id: '6',
    title: '大江大河3：春风又绿江南岸',
    englishTitle: 'Like a Flowing River 3',
    year: 2025,
    category: '电视剧',
    categorySlug: 'tv',
    rating: 9.1,
    description: '改革开放的春风拂过神州大地，宋运辉、雷东宝、杨巡三人在各自的道路上继续前行。宋运辉在国企改革的浪潮中奋勇拼搏，雷东宝带领村民迈向共同富裕，杨巡在商海中披荆斩棘。时代洪流中，每个人都在书写着属于自己的奋斗史诗。',
    posterImage: 'https://readdy.ai/api/search-image?query=A%20period%20Chinese%20drama%20poster%20showing%20three%20men%20in%201990s%20Chinese%20business%20attire%20standing%20before%20a%20modernizing%20city%20skyline%20warm%20golden%20light%20dramatic%20cinematic%20composition%20clean%20background&width=600&height=840&seq=movie-poster-06&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=1990s%20Chinese%20cityscape%20with%20modern%20buildings%20rising%20construction%20sites%20river%20with%20bridges%20warm%20golden%20sunset%20light%20prosperous%20atmosphere%20cinematic%20quality%20epic%20urban%20landscape&width=1600&height=700&seq=movie-banner-06&orientation=landscape',
    director: '孔笙',
    cast: ['王凯', '杨烁', '董子健', '杨采钰', '张佳宁', '练练'],
    duration: '40集',
    type: 'tv',
    region: '中国大陆',
    updateStatus: '全40集',
    tags: ['年代', '改革开放', '商战', '励志', '阿耐'],
    featured: false,
    releaseDate: '2025-09-20',
    viewCount: 89000000,
  },
  {
    id: '7',
    title: '刀尖2：暗夜追踪',
    englishTitle: 'On the Edge 2',
    year: 2026,
    category: '剧情片',
    categorySlug: 'drama',
    rating: 8.6,
    description: '谍战风云再起，1940年代的上海滩暗流涌动。潜伏在敌人心脏的地下党员方菲接到了一项不可能完成的任务——在72小时内截获一份关于盟军登陆计划的绝密文件。在步步惊心的追击与反追击中，她必须在信仰与牺牲之间做出抉择。',
    posterImage: 'https://readdy.ai/api/search-image?query=A%20stylish%20spy%20thriller%20movie%20poster%20showing%20a%20woman%20in%201940s%20cheongsam%20holding%20a%20pistol%20dim%20lit%20Shanghai%20alley%20background%20noir%20lighting%20dramatic%20shadows%20vintage%20cinematic%20style%20clean%20dark%20background&width=600&height=840&seq=movie-poster-07&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=1940s%20Shanghai%20street%20at%20night%20with%20neon%20signs%20vintage%20cars%20rain%20on%20cobblestone%20film%20noir%20atmosphere%20dramatic%20lighting%20shadows%20art%20deco%20buildings%20cinematic%20quality&width=1600&height=700&seq=movie-banner-07&orientation=landscape',
    director: '高群书',
    cast: ['张译', '黄志忠', '郎月婷', '成泰燊', '沙溢', '高捷'],
    duration: '121分钟',
    type: 'movie',
    region: '中国大陆',
    updateStatus: '已上映',
    tags: ['谍战', '悬疑', '1940年代', '上海滩', '惊悚'],
    featured: false,
    releaseDate: '2026-04-05',
    viewCount: 45200000,
  },
  {
    id: '8',
    title: '哪吒之魔童闹海2',
    englishTitle: 'Ne Zha 2',
    year: 2026,
    category: '动画片',
    categorySlug: 'animation',
    rating: 9.3,
    description: '天劫之后，哪吒和敖丙虽然保住了魂魄，但肉身濒临崩溃。太乙真人用七色宝莲为他们重塑肉身，然而过程中却遭遇了重重困难。与此同时，一股来自东海深处的神秘力量正在悄然崛起，三界将再次面临一场前所未有的浩劫。哪吒必须尽快恢复力量，迎接新的挑战。',
    posterImage: 'https://readdy.ai/api/search-image?query=A%20vibrant%20Chinese%20animation%20movie%20poster%20showing%20a%20young%20mythical%20warrior%20with%20fire%20powers%20riding%20wind%20fire%20wheels%20dramatic%20dynamic%20composition%20vibrant%20red%20and%20gold%20colors%20traditional%20Chinese%20art%20style%20clean%20background&width=600&height=840&seq=movie-poster-08&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20animation%20scene%20showing%20celestial%20palace%20in%20clouds%20with%20golden%20dragons%20and%20phoenixes%20vibrant%20colors%20traditional%20Chinese%20ink%20painting%20style%20cinematic%20lighting%20dynamic%20composition%20epic%20scale&width=1600&height=700&seq=movie-banner-08&orientation=landscape',
    director: '饺子',
    cast: ['吕艳婷', '囧森瑟夫', '瀚墨', '陈浩', '绿绮', '张珈铭'],
    duration: '142分钟',
    type: 'movie',
    region: '中国大陆',
    updateStatus: '已上映',
    tags: ['动画', '神话', '封神', '国漫', '3D'],
    featured: true,
    releaseDate: '2026-07-12',
    viewCount: 210000000,
  },
  {
    id: '9',
    title: '门前宝地2',
    englishTitle: '100 Yards 2',
    year: 2026,
    category: '动作片',
    categorySlug: 'action',
    rating: 7.8,
    description: '民国天津，武术界暗潮涌动。武馆馆长突然离世，留下一块"门前宝地"的百年规矩——谁能在门前百步之内站住脚，谁就是下一任馆长。各大门派闻风而动，一场关乎荣誉与传承的武林争霸赛就此展开。拳拳到肉的真功夫对决，将民国武林的风骨展现得淋漓尽致。',
    posterImage: 'https://readdy.ai/api/search-image?query=A%20martial%20arts%20movie%20poster%20showing%20a%20kung%20fu%20master%20in%20traditional%20Chinese%20clothing%20striking%20a%20powerful%20pose%20in%20front%20of%20old%20Chinese%20architecture%20dramatic%20lighting%20dust%20particles%20warm%20sepia%20tones%20clean%20background&width=600&height=840&seq=movie-poster-09&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20martial%20arts%20school%20courtyard%20with%20wooden%20training%20equipment%20old%20Chinese%20architecture%20morning%20mist%20warm%20golden%20light%20dust%20particles%20in%20sunbeams%20cinematic%20atmosphere%20vintage%20China&width=1600&height=700&seq=movie-banner-09&orientation=landscape',
    director: '徐浩峰',
    cast: ['向佐', '郭碧婷', '安志杰', '唐诗逸', '李媛', '赵峥'],
    duration: '115分钟',
    type: 'movie',
    region: '中国大陆',
    updateStatus: '已上映',
    tags: ['动作', '武术', '民国', '武侠', '徐浩峰'],
    featured: false,
    releaseDate: '2026-06-08',
    viewCount: 31500000,
  },
  {
    id: '10',
    title: '大决战之淮海战役',
    englishTitle: 'Decisive Engagement: Huaihai Campaign',
    year: 2026,
    category: '剧情片',
    categorySlug: 'drama',
    rating: 9.5,
    description: '1948年冬，淮海大平原上，一场决定中国命运的大决战轰然打响。六十万对八十万，人民解放军以少胜多，创造了一个战争史上的奇迹。影片从多个视角展现这场惊心动魄的战役——指挥部的运筹帷幄、前线将士的浴血奋战、支前民工的滚滚车轮，共同谱写了一曲气壮山河的英雄赞歌。',
    posterImage: 'https://readdy.ai/api/search-image?query=A%20powerful%20war%20movie%20poster%20showing%20soldiers%20charging%20across%20a%20battlefield%20at%20dawn%20with%20smoke%20and%20explosions%20dramatic%20cinematic%20lighting%20epic%20scale%20warm%20orange%20and%20smoke%20tones%20clean%20dark%20background&width=600&height=840&seq=movie-poster-10&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Epic%20historical%20war%20battlefield%20scene%20at%20dawn%20with%20thousands%20of%20soldiers%20marching%20smoke%20and%20dust%20dramatic%20sky%20cinematic%20lighting%20massive%20scale%20golden%20hour%20atmosphere%20historical%20Chinese%20battle&width=1600&height=700&seq=movie-banner-10&orientation=landscape',
    director: '黄建新',
    cast: ['唐国强', '刘劲', '王伍福', '郭连文', '王健', '卢奇'],
    duration: '156分钟',
    type: 'movie',
    region: '中国大陆',
    updateStatus: '已上映',
    tags: ['战争', '历史', '淮海战役', '史诗', '主旋律'],
    featured: false,
    releaseDate: '2026-10-01',
    viewCount: 68000000,
  },
  {
    id: '11',
    title: '三体：黑暗森林',
    englishTitle: 'Three-Body: The Dark Forest',
    year: 2026,
    category: '科幻片',
    categorySlug: 'scifi',
    rating: 9.6,
    description: '面壁计划启动。面对四百年后即将抵达的三体舰队，人类选出了四位面壁者，赋予他们调动全球资源的绝对权力，让他们在思维层面上与三体文明展开一场看不见的博弈。罗辑，一个毫不起眼的社会学教授，却掌握着宇宙最黑暗的秘密——黑暗森林法则。',
    posterImage: 'https://readdy.ai/api/search-image?query=A%20mind-bending%20sci-fi%20movie%20poster%20showing%20a%20cosmic%20forest%20made%20of%20stars%20and%20darkness%20with%20a%20human%20silhouette%20standing%20at%20the%20edge%20mysterious%20atmosphere%20deep%20space%20philosophical%20tone%20clean%20dark%20background&width=600&height=840&seq=movie-poster-11&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Cosmic%20dark%20forest%20concept%20showing%20a%20vast%20universe%20filled%20with%20stars%20and%20dark%20matter%20mysterious%20glowing%20particles%20deep%20space%20atmosphere%20enormous%20scale%20philosophical%20sci-fi%20tone%20cinematic%20quality&width=1600&height=700&seq=movie-banner-11&orientation=landscape',
    director: '张艺谋',
    cast: ['易烊千玺', '张译', '陈道明', '于和伟', '王子文', '李小冉'],
    duration: '175分钟',
    type: 'movie',
    region: '中国大陆',
    updateStatus: '即将上映',
    tags: ['科幻', '三体', '刘慈欣', '宇宙', '哲学', '国产科幻'],
    featured: true,
    releaseDate: '2026-12-25',
    viewCount: 0,
  },
  {
    id: '12',
    title: '舌尖上的中国·寻味',
    englishTitle: 'A Bite of China: The Search',
    year: 2026,
    category: '纪录片',
    categorySlug: 'documentary',
    rating: 9.3,
    description: '跨越山海，寻找最纯粹的中国味道。从东北雪原上的铁锅炖，到岭南水乡的早茶文化；从西南深山的野生菌，到东南沿海的渔家鲜味。每一道美食背后，都是一个关于土地、人文与传统的故事。这是一场唤醒味蕾的奇妙旅程，更是一次深入中国饮食文化灵魂的探索。',
    posterImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20food%20documentary%20poster%20showing%20traditional%20Chinese%20cuisine%20dishes%20steaming%20hot%20arranged%20artistically%20on%20a%20dark%20wooden%20table%20warm%20lighting%20mouthwatering%20presentation%20clean%20dark%20background&width=600&height=840&seq=movie-poster-12&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Stunning%20Chinese%20food%20landscape%20showing%20traditional%20market%20with%20fresh%20ingredients%20steaming%20street%20food%20stalls%20morning%20light%20warm%20atmosphere%20bustling%20crowd%20beautiful%20textures%20cinematic%20food%20photography%20epic%20scale&width=1600&height=700&seq=movie-banner-12&orientation=landscape',
    director: '陈晓卿',
    cast: ['李立宏'],
    duration: '10集',
    type: 'tv',
    region: '中国大陆',
    updateStatus: '全10集',
    tags: ['纪录片', '美食', '文化', '人文', '中国'],
    featured: false,
    releaseDate: '2026-04-20',
    viewCount: 56000000,
  },
];

export const featuredMovies = movies.filter(m => m.featured);
export const latestMovies = [...movies].sort((a, b) => new Date(b.releaseDate).getTime() - new Date(a.releaseDate).getTime());
export const popularMovies = [...movies].sort((a, b) => b.viewCount - a.viewCount);

export function getMoviesByCategory(slug: string): Movie[] {
  if (slug === 'all') return movies;
  return movies.filter(m => m.categorySlug === slug);
}

export function getMovieById(id: string): Movie | undefined {
  return movies.find(m => m.id === id);
}

export function getRelatedMovies(movie: Movie, count: number = 6): Movie[] {
  return movies
    .filter(m => m.id !== movie.id && (m.categorySlug === movie.categorySlug || m.tags.some(t => movie.tags.includes(t))))
    .slice(0, count);
}